const outside = {};

function onClick(el, binding) {
	return event => {
		binding.value.outside(event, el);
	};
}

outside.inserted = (el, binding) => {
	const key = binding.value.name;
	outside[key] = onClick(el, binding);
	document.addEventListener('click', outside[key]);
};

outside.unbind = (el, binding) => {
	const key = binding.value.name;
	document.removeEventListener('click', outside[key]);
	delete outside[key];
};

export default outside;
